<template>
  <Page>
    <SidePageColumn side="left">
      <v-list shaped dense max-width="98.5%" class="grey lighten-5">
        <v-subheader class="pl-5">Manage Items Toolbar</v-subheader>
        <v-list-item-group color="primary" class="pl-3">
          <SideMenuItem
            v-for="(menu_item, index) in admin_menu_objects"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></SideMenuItem>
        </v-list-item-group>
      </v-list>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-hide-loader')"
        @on-hide-loader="$emit('on-show-loader')"
      ></router-view>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
  </Page>
</template>
<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import NavbarMenuItem from "../../components/NavbarMenuItem";
import SideMenuItem from "../../components/SideMenuItem";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";
import CenterPageColumn from "./../../components/CenterPageColumn";
import Footer from "./../../components/CenterFooter";
export default {
  name: "Admin",
  components: {
    Page,
    NavbarMenuItem,
    SideMenuItem,
    SidePageColumn,
    CenterPageColumn,
    Footer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      admin_menu_objects: [
        {
          label: "Dashboard",
          icon: "mdi-home-city-outline",
          to: "/admin/dashboard",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Promotions",
          icon: "mdi-home-city-outline",
          to: "/admin/promotions",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Business",
          icon: "mdi-home-city-outline",
          to: "/admin/businesses",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Categories",
          icon: "mdi-home-city-outline",
          to: "/admin/categories",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Locations",
          icon: "mdi-home-city-outline",
          to: "/admin/locations",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Hollidays",
          icon: "mdi-home-city-outline",
          to: "/admin/hollidays",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "News Letters",
          icon: "mdi-home-city-outline",
          to: "/admin/new_letters",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Contact Messages",
          icon: "mdi-home-city-outline",
          to: "/admin/contact_us_messages",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "users",
          icon: "mdi-home-city-outline",
          to: "/admin/users",
          roles: ["super role", "backofficcee"],
        }
      ],
      user: null,
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
  },
  mounted() {
    this.user = ServerClient.Login.get_logged_in_user();
  },
};
</script>